WiseMetering.Collection.Companies = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Company,
    url: '/companies',
    comparator: 'name'
});
